import { render, staticRenderFns } from "./ChatInputMenu.vue?vue&type=template&id=3da19e9e&scoped=true&"
import script from "./ChatInputMenu.vue?vue&type=script&lang=ts&"
export * from "./ChatInputMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ChatInputMenu.vue?vue&type=style&index=0&id=3da19e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da19e9e",
  null
  
)

export default component.exports